// frontend/src/hooks/useEntityAlerts.js
import { useState, useEffect, useCallback } from 'react';
import API from '../services/api';

/**
 * Fetch and manage row-level alert states for a given entity type.
 *
 * @param {string} entityType  – 'partner' | 'client'
 * @returns {{ alertMap, markSeen, markTreated, refresh }}
 *   alertMap: { [entity_id]: 'new' | 'seen' | 'treated' }
 */
const useEntityAlerts = (entityType) => {
  const [alertMap, setAlertMap] = useState({});

  const refresh = useCallback(async () => {
    if (!entityType) return;
    try {
      const res = await API.get('/notifications/alerts', { params: { entity_type: entityType } });
      setAlertMap(res.data.alerts || {});
    } catch (_) {}
  }, [entityType]);

  useEffect(() => { refresh(); }, [refresh]);

  const ack = useCallback(async (entityId, status) => {
    try {
      await API.put('/notifications/alerts/ack', {
        entity_type: entityType,
        entity_id: entityId,
        status,
      });
      // Optimistic update
      setAlertMap(prev => ({ ...prev, [String(entityId)]: status }));
    } catch (_) {}
  }, [entityType]);

  const markSeen    = useCallback((id) => ack(id, 'seen'),    [ack]);
  const markTreated = useCallback((id) => ack(id, 'treated'), [ack]);

  return { alertMap, markSeen, markTreated, refresh };
};

export default useEntityAlerts;
